import React from 'react';
var CaretUp = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 30 30" },
        React.createElement("polygon", { fill: fill, points: "15 5.55 30 20.55 26.096481 24.453519 15.0000667 13.3569503 3.90351896 24.453519 0 20.55" })));
};
export default CaretUp;
